import * as React from 'react';
import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import { DatePicker, TimePicker, MultiViewCalendar, MultiViewCalendarChangeEvent } from '@progress/kendo-react-dateinputs';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { fetchApi, JsonResponse } from '../../services/api';
import * as $ from 'jquery';
import LoadingPanel from '../LoadingPanel';
import LoadingButton from '../LoadingButton';
import { ScheduleEditModal } from './ScheduleEditModal';
import { IDName } from '../Accounts/Payments';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';

type Props = RouteComponentProps<{
    childId: string;
}>

type State = {
    schedule: ScheduleData[];
    isLoading: boolean;

    currentYear: number;
    currentMonth: number;
    childId: number;

    // Editing
    editLink: ApiLink | null;

    // New Record
    daysOfWeek: number[];
    generateMode: number;
    generationStartDate: Date | null;
    generationEndDate: Date | null;
    generationDates: Date[];
    startTime: Date | null;
    endTime: Date | null;
    instructorId: number | null;

	instructors: IDName[];
}

type ScheduleData = {
    ChildScheduleID: number;
    FacilityName: string;
    StartTime: Date;
    EndTime: Date;
    InstructorId: number | null;
}

export default class Schedule extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            schedule: [],

            currentYear: moment().year(),
            currentMonth: parseInt(moment().format("M")),

            editLink: null,

            childId: 0,
            daysOfWeek: [1,2,3,4,5],
            generateMode: 0,
            generationDates: [],
            generationStartDate: null,
            generationEndDate: null,
            startTime: null,
            endTime: null,
            instructorId: null,

            instructors: []
        }

        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.deleteFuture = this.deleteFuture.bind(this);
        this.deleteAll = this.deleteAll.bind(this);
        this.requestSchedule = this.requestSchedule.bind(this);
        this.onChangeCalendar = this.onChangeCalendar.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestSchedule(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.schedule && this.state.childId != childId) {
            this.requestSchedule(childId);
        }
    }

    public render() {
        return <React.Fragment>
            <br />
            {this.state.isLoading && <LoadingPanel />}
            {this.state.editLink && <ScheduleEditModal
                CloseDialog={() => this.setState({ editLink: null })}
                RefreshSchedule={() => this.requestSchedule(this.state.childId)}
                Link={this.state.editLink} />}
            <div className="row">
                <div className="col">
                    <h3>{moment(`${this.state.currentYear}-${this.state.currentMonth}`, 'YYYY-M').format("MMMM YYYY")}</h3>
                </div>
                <div className="col">
                    <div className="float-right">
                        <button type="button" className="btn btn-success" data-toggle="modal" data-target=".bd-example-modal-lg">Create Schedule</button>
                        <div className="modal fade bd-example-modal-lg" tabIndex={-1} role="dialog" id="myModal">
                            <div className="modal-dialog modal-lg" role="document">
                                <div className="modal-content k-form">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Create Schedule</h5>
                                        <button type="button" className="btn btn-sm btn-secondary dropdown-toggle ml-auto" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Presets
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a className="dropdown-item" href="#" onClick={(e) => this.setPreset(e, [1,2,3,4,5], { hour: 8 }, { hour: 17 })}>Weekdays (8AM - 5PM)</a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.setPreset(e, [1,2,3,4,5], { hour: 8 }, { hour: 12 })}>Weekdays (8AM - 12PM)</a>
                                            <a className="dropdown-item" href="#" onClick={(e) => this.setPreset(e, [1,2,3,4,5], { hour: 12 }, { hour: 17 })}>Weekdays (12PM - 5PM)</a>
                                        </div>
                                        <button type="button" className="close ml-0" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <TabStrip selected={this.state.generateMode} onSelect={(e) => this.setState({ generateMode: e.selected })}>
                                            <TabStripTab title="Schedule Range">
                                                <div className="form-group">
                                                    <label htmlFor="daysOfWeek">Schedule Days</label>
                                                    <ButtonGroup>
                                                        <Button
                                                            togglable={true}
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    daysOfWeek: this.state.daysOfWeek.indexOf(0) > -1 ?
                                                                    this.state.daysOfWeek.filter(x => x !== 0) : [...this.state.daysOfWeek, 0]
                                                                })
                                                            }}
                                                            selected={this.state.daysOfWeek.indexOf(0) > -1}
                                                            primary={this.state.daysOfWeek.indexOf(0) > -1}
                                                        >
                                                            Sunday
                                                        </Button>
                                                        <Button
                                                            togglable={true}
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    daysOfWeek: this.state.daysOfWeek.indexOf(1) > -1 ?
                                                                    this.state.daysOfWeek.filter(x => x !== 1) : [...this.state.daysOfWeek, 1]
                                                                })
                                                            }}
                                                            selected={this.state.daysOfWeek.indexOf(1) > -1}
                                                            primary={this.state.daysOfWeek.indexOf(1) > -1}
                                                        >
                                                            Monday
                                                        </Button>
                                                        <Button
                                                            togglable={true}
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    daysOfWeek: this.state.daysOfWeek.indexOf(2) > -1 ?
                                                                    this.state.daysOfWeek.filter(x => x !== 2) : [...this.state.daysOfWeek, 2]
                                                                })
                                                            }}
                                                            selected={this.state.daysOfWeek.indexOf(2) > -1}
                                                            primary={this.state.daysOfWeek.indexOf(2) > -1}
                                                        >
                                                            Tuesday
                                                        </Button>
                                                        <Button
                                                            togglable={true}
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    daysOfWeek: this.state.daysOfWeek.indexOf(3) > -1 ?
                                                                    this.state.daysOfWeek.filter(x => x !== 3) : [...this.state.daysOfWeek, 3]
                                                                })
                                                            }}
                                                            selected={this.state.daysOfWeek.indexOf(3) > -1}
                                                            primary={this.state.daysOfWeek.indexOf(3) > -1}
                                                        >
                                                            Wednesday
                                                        </Button>
                                                        <Button
                                                            togglable={true}
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    daysOfWeek: this.state.daysOfWeek.indexOf(4) > -1 ?
                                                                    this.state.daysOfWeek.filter(x => x !== 4) : [...this.state.daysOfWeek, 4]
                                                                })
                                                            }}
                                                            selected={this.state.daysOfWeek.indexOf(4) > -1}
                                                            primary={this.state.daysOfWeek.indexOf(4) > -1}
                                                        >
                                                            Thursday
                                                        </Button>
                                                        <Button
                                                            togglable={true}
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    daysOfWeek: this.state.daysOfWeek.indexOf(5) > -1 ?
                                                                    this.state.daysOfWeek.filter(x => x !== 5) : [...this.state.daysOfWeek, 5]
                                                                })
                                                            }}
                                                            selected={this.state.daysOfWeek.indexOf(5) > -1}
                                                            primary={this.state.daysOfWeek.indexOf(5) > -1}
                                                        >
                                                            Friday
                                                        </Button>
                                                        <Button
                                                            togglable={true}
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    daysOfWeek: this.state.daysOfWeek.indexOf(6) > -1 ?
                                                                    this.state.daysOfWeek.filter(x => x !== 6) : [...this.state.daysOfWeek, 6]
                                                                })
                                                            }}
                                                            selected={this.state.daysOfWeek.indexOf(6) > -1}
                                                            primary={this.state.daysOfWeek.indexOf(6) > -1}
                                                        >
                                                            Saturday
                                                        </Button>
                                                    </ButtonGroup>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="generationStartDate">Schedule Start Date</label>
                                                    <DatePicker
                                                        format="MM/dd/yyyy"
                                                        formatPlaceholder="formatPattern"
                                                        value={this.state.generationStartDate}
                                                        onChange={(e) => this.setState({ generationStartDate: e.value })}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="generationEndDate">Schedule End Date</label>
                                                    <DatePicker
                                                        format="MM/dd/yyyy"
                                                        formatPlaceholder="formatPattern"
                                                        value={this.state.generationEndDate}
                                                        onChange={(e) => this.setState({ generationEndDate: e.value })}
                                                    />
                                                </div>
                                            </TabStripTab>
                                            <TabStripTab title="Select Days">
                                                <MultiViewCalendar
                                                    views={1}
                                                    value={this.state.generationDates}
                                                    onChange={this.onChangeCalendar}
                                                />
                                            </TabStripTab>
                                        </TabStrip>

                                        <div className="form-group">
                                            <label htmlFor="startTime">Start Time</label>
                                            <TimePicker
                                                name="StartTime"
                                                format="hh:mm a"
                                                formatPlaceholder="formatPattern"
                                                className="form-control"
                                                value={this.state.startTime}
                                                onChange={(e) => this.setState({ startTime: e.value})}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="endTime">End Time</label>
                                            <TimePicker
                                                name="EndTime"
                                                format="hh:mm a"
                                                formatPlaceholder="formatPattern"
                                                className="form-control"
                                                value={this.state.endTime}
                                                onChange={(e) => this.setState({ endTime: e.value})}
                                            />
                                        </div>
										<div className="form-group">
											<label htmlFor="instructor">Instructor</label>
											<DropDownList
                                                data={this.state.instructors}
                                                textField="Name"
                                                defaultItem={{ID: 0, Name: "Select Instructor..."}}
                                                value={this.state.instructors.find(x => x.ID == 0)}
                                                onChange={(e) => this.setState({ instructorId: e.target.value.ID})}
                                           />
										</div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-default mr-auto" data-dismiss="modal">Close</button>
                                        <LoadingButton className="btn btn-success" onClick={this.save} isLoading={this.state.isLoading}>Create Schedule</LoadingButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        &nbsp;&nbsp;
                        <button type="button" className="btn btn-primary" onClick={this.prev}>
                            Prev Month
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" className="btn btn-primary" onClick={this.next}>
                            Next Month
                        </button>
                    </div>
                </div>
            </div>
            <br/>
            {!this.state.isLoading && this.state.schedule.map((schedule, index) => {
                return (
                    <div className="Card" key={index}>
                        <div className="row">
                            <div className="col">
                                <Link className="h5" to={`/child/${this.state.childId}/schedule/${schedule.ChildScheduleID}/activities`}>{moment.utc(schedule.StartTime).local().format("dddd, MMMM Do YYYY")}</Link>
                                <br />
                                {moment.utc(schedule.StartTime).format("hh:mm a")} - {moment.utc(schedule.EndTime).format("hh:mm a")}
                                <br />
                                Instructor: {(schedule.InstructorId == 0) ? "None" : this.state.instructors.find(x => x.ID == schedule.InstructorId).Name}
                                <br />
                                <span className="text-muted">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-map-pin">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                        <circle cx="12" cy="10" r="3"></circle>
                                    </svg>
                                    &nbsp;
                                    {schedule.FacilityName}
                                </span>
                            </div>
                            <div className="col">
                                <div className="btn-group float-right" role="group" aria-label="Button group with nested dropdown">
                                    <button type="button" className="btn btn-secondary" onClick={(e) => this.openEdit(e, schedule.ChildScheduleID)}>
                                        Edit
                                    </button>
                                    <button id="btnGroupDrop1" type="button" className="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Delete
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop1">
                                        <a
                                            href="#"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (confirm(`Delete this visit?`)) {
                                                    this.delete(schedule.ChildScheduleID);
                                                }
                                            }}
                                        >This visit</a>
                                        <a
                                            href="#"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (confirm(`Delete this AND future visits?`)) {
                                                    this.deleteFuture(schedule.ChildScheduleID);
                                                }
                                            }}
                                        >This and following visits</a>
                                        <a
                                            href="#"
                                            className="dropdown-item"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (confirm(`Delete ALL visits?`)) {
                                                    this.deleteAll(this.state.childId);
                                                }
                                            }}
                                        >All visits</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>);
            })}
            {!this.state.isLoading && this.state.schedule.length === 0 && <h3 style={{ textAlign: 'center' }}>No Schedule Defined</h3>}
        </React.Fragment>
    }

    private openEdit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, childScheduleID: number): void {
        e.preventDefault();

        this.setState({ editLink: { Rel: "GetSchedule", Method: "GET", Href: `api/ChildSchedule/Get/${childScheduleID}` }});
    }

    private setPreset(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, daysOfWeek: number[], start: { hour: number, minute?: number }, end: { hour: number, minute?: number }) {
        e.preventDefault();

        var startTime = new Date();
        startTime.setHours(start.hour);
        startTime.setMinutes(start.minute || 0);

        var endTime = new Date();
        endTime.setHours(end.hour);
        endTime.setMinutes(end.minute || 0);

        this.setState({ generateMode: 0, daysOfWeek, startTime, endTime });
    }

    private prev() {
        if (this.state.currentMonth === 1) {
            this.setState({ currentMonth: 12, currentYear: this.state.currentYear - 1 },
                () => this.requestSchedule(this.state.childId));
        } else {
            this.setState({ currentMonth: this.state.currentMonth - 1 },
                () => this.requestSchedule(this.state.childId));
        }
    }

    private next() {
        if (this.state.currentMonth === 12) {
            this.setState({ currentMonth: 1, currentYear: this.state.currentYear + 1 },
                () => this.requestSchedule(this.state.childId));
        } else {
            this.setState({ currentMonth: this.state.currentMonth + 1 },
                () => this.requestSchedule(this.state.childId));
        }
    }

    private save() {
        if (this.state.startTime === null) {
            alert("Please enter a valid start time.");
            return;
        }

        if (this.state.endTime === null) {
            alert("Please enter a valid end time.");
            return;
        }

        if (this.state.generateMode === 0 && this.state.generationStartDate === null) {
            alert("Please enter an schedule start date.");
            return;
        }

        if (this.state.generateMode === 0 && this.state.generationEndDate === null) {
            alert("Please enter an scedule end date.");
            return;
        }

        if (this.state.generateMode === 1 && this.state.generationDates.length === 0) {
            alert("Please select atleast one date.");
            return;
        }

        if (this.state.generationStartDate > this.state.generationEndDate) {
            alert("Schedule end date cannot be before start date.");
            return;
        }

        const data = {
            DaysOfWeek: this.state.daysOfWeek,
            GenerationStartDate: this.state.generationStartDate,
            GenerationEndDate: this.state.generationEndDate,
            StartTime: moment(this.state.startTime).format("hh:mm a"),
            EndTime:  moment(this.state.endTime).format("hh:mm a"),
            InstructorId: this.state.instructorId
        } as any;

        if (this.state.generateMode == 1) {
            delete data.GenerationStartDate;
            delete data.GenerationEndDate;
            data.GenerationDates = this.state.generationDates;
        }

        this.setState({ isLoading: true });
        fetchApi(`api/ChildSchedule/Create/${this.state.childId}`, data, 'POST')
            .then((response: JsonResponse) => {
                if (response.Success) {
                    this.setState({ generationDates: [] });
                    $('#myModal').modal('hide');
                    this.requestSchedule(this.state.childId);
                } else {
                    this.setState({ isLoading: false });
                    alert(response.ErrorMessage);
                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                alert("Failed to create schedule!");
            });

    }

    private onChangeCalendar(e: MultiViewCalendarChangeEvent<MultiViewCalendar>) {
        if (e.value instanceof Date) {
            const date = e.value as Date;
            this.setState(prevState => ({ generationDates: prevState.generationDates.some(d => d.getTime() === date.getTime()) ?
                prevState.generationDates.filter(x => x.getTime() !== date.getTime()) : [...prevState.generationDates, date]}));
        } else if (Array.isArray(e.value)) {
            const dates = e.value as Date[];
            dates.forEach(date => {
                this.setState(prevState => ({ generationDates: prevState.generationDates.some(d => d.getTime() === date.getTime()) ?
                    prevState.generationDates.filter(x => x.getTime() !== date.getTime()) : [...prevState.generationDates, date]}));
            });
        }
    }

    private delete(childScheduleID: number) {
        this.setState({ isLoading: true });
        fetchApi(`api/ChildSchedule/Delete/${childScheduleID}`, {}, 'DELETE')
        .then(() => {
            const schedule = this.state.schedule.filter(x => x.ChildScheduleID !== childScheduleID).slice();
            this.setState({ isLoading: false, schedule });
        });
    }

    private deleteFuture(childScheduleID: number) {
        this.setState({ isLoading: true });
        fetchApi(`api/ChildSchedule/DeleteFuture/${childScheduleID}`, {}, 'DELETE')
        .then(() => {
            this.requestSchedule(this.state.childId);
        });
    }

    private deleteAll(childID: number) {
        this.setState({ isLoading: true });
        fetchApi(`api/ChildSchedule/DeleteAll/${childID}`, {}, 'DELETE')
        .then(() => {
            this.setState({ isLoading: false, schedule: [] });
        });
    }

    private requestSchedule(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/ChildSchedule/List/${childId}/${this.state.currentYear}/${this.state.currentMonth}`)
            .then((response: { Schedules: ScheduleData[], Instructors: IDName[] }) => {
                this.setState({ isLoading: false, schedule: response.Schedules, instructors: response.Instructors });
            });
    }
}
